import { useEffect, useRef } from 'react';
import {
    BREAKPOINTS,
    useBreakpoint
} from 'tradera-components/breakpoint/breakpoint';

export const useMenuHeightFix = () => {
    const menuContentRef = useRef();
    const currentBreakpoint = useBreakpoint();

    useEffect(() => {
        if (!menuContentRef.current) return;
        const element = menuContentRef.current.parentElement;
        const marginBottom = currentBreakpoint === BREAKPOINTS.XL ? 7 : 0;
        const marginTop = element.getBoundingClientRect().top;
        const marginY = marginTop + marginBottom;
        element.style.maxHeight = `calc(100vh - ${marginY}px)`;
    }, [currentBreakpoint]);
    return menuContentRef;
};
